<app-card-content [border]="false" icon="pi pi-user-edit" [title]="'Atribuir Roles'" [subtitle]="'Vincule ou remova roles de um usuário'">
    @if (!userIdAtivo()) {
        <app-table-view-switcher card-header [(viewMode)]="viewMode" />
    }
    @if (userIdAtivo()) {
        <div class="flex items-center justify-between gap-3 flex-wrap mb-4 pb-4 border-b border-surface-200 dark:border-surface-700">
            <div class="flex items-center gap-3">
                <app-pessoa-avatar [foto]="avatarAtivo()" [iniciais]="iniciais(nomeAtivo() || '?')" [nome]="nomeAtivo() || ''" tamanho="xl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, nomeAtivo() || '')" />
                <div class="flex flex-col gap-1">
                    <span class="font-semibold text-base">{{ nomeAtivo() || userIdAtivo() }}</span>
                    <div class="flex items-center gap-2 flex-wrap">
                        @if (ufAtivo()) {
                            <span class="text-sm text-muted-color">UF: {{ ufAtivo() }}</span>
                        }
                        @for (p of perfisAtivos(); track p.idWebPerfil) {
                            <span class="perfil-chip text-sm inline-flex items-center gap-1.5 bg-primary/10 text-primary font-semibold pl-2.5 pr-1 py-1 rounded-full">
                                <i class="pi pi-id-card" style="font-size: 0.85rem"></i>
                                {{ p.nmPerfil }}
                                <button
                                    type="button"
                                    class="perfil-chip-remove inline-flex items-center justify-center w-5 h-5 rounded-full text-primary hover:bg-primary/20 disabled:opacity-40 disabled:cursor-not-allowed"
                                    pTooltip="Remover perfil"
                                    tooltipPosition="top"
                                    [disabled]="removendoPerfil() || removendoTodas()"
                                    [appCan]="rolePermissaoAdministrar"
                                    (click)="confirmarRemoverPerfil(p)"
                                >
                                    <i class="pi pi-times" style="font-size: 0.7rem"></i>
                                </button>
                            </span>
                        }
                    </div>
                </div>
            </div>
            <div class="flex items-center gap-2">
                @if (!userId()) {
                    <p-button label="Trocar usuário" icon="pi pi-arrow-left" severity="secondary" size="small" (onClick)="trocarUsuario()"></p-button>
                }
            </div>
        </div>
    }

    @if (userIdAtivo() && perfisExcluidos().length) {
        <div class="aviso-perfil-excluido flex flex-col gap-3 mb-4 rounded-lg border border-amber-300 dark:border-amber-700/60 bg-amber-50 dark:bg-amber-950/30 text-amber-800 dark:text-amber-200 p-3">
            @for (p of perfisExcluidos(); track p.idWebPerfil) {
                <div class="flex flex-col gap-2">
                    <div class="flex items-start gap-2 text-sm">
                        <i class="pi pi-exclamation-triangle mt-0.5 shrink-0"></i>
                        <span
                            >O perfil <strong>«{{ p.nmPerfil }}»</strong> foi excluído, mas as roles abaixo foram mantidas para este usuário:</span
                        >
                    </div>
                    @if (p.roles?.length) {
                        <div class="flex flex-wrap gap-1.5 pl-6">
                            @for (r of p.roles; track r) {
                                <span class="text-sm font-mono break-all whitespace-normal rounded bg-amber-100 dark:bg-amber-900/40 text-amber-900 dark:text-amber-100 px-2 py-0.5">{{ r }}</span>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (!userIdAtivo()) {
        <!-- Filtros -->
        <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
            <app-filtro-campo label="UF">
                <app-estado-select [uf]="filtroUf()" [disabled]="ufTravada()" (ufChange)="filtroUf.set($event)" />
            </app-filtro-campo>
            <app-filtro-campo label="Nome ou User ID" [wide]="true" inputId="atribuir-roles-filtro-usuario">
                <input id="atribuir-roles-filtro-usuario" pInputText type="text" class="w-full" [ngModel]="filtroUsuario()" (ngModelChange)="filtroUsuario.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Buscar usuário por nome ou id..." />
            </app-filtro-campo>
        </app-filtros-bar>

        @if (viewMode() === 'table') {
            <p-table [value]="usuariosFiltrados()" styleClass="p-datatable-sm" [rowHover]="true" stripedRows [paginator]="true" [rows]="10">
                <ng-template pTemplate="header"
                    ><tr>
                        <th style="width: 88px"></th>
                        <th>Usuário</th>
                        <th style="width: 60px" class="text-center">UF</th>
                        <th style="width: 8rem"></th></tr
                ></ng-template>
                <ng-template pTemplate="body" let-u>
                    <tr>
                        <td>
                            <app-pessoa-avatar [foto]="u.avatar" [iniciais]="iniciais(u.nmSolicitante || u.userId)" [nome]="u.nmSolicitante || ''" tamanho="xxl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, u.nmSolicitante || '')" />
                        </td>
                        <td>
                            <div class="flex flex-col gap-0.5">
                                <span class="font-medium text-sm">{{ u.nmSolicitante || u.userId }}</span>
                                @if (u.cpf) {
                                    <span class="text-xs text-muted-color">{{ u.cpf }}</span>
                                }
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="text-xs font-semibold text-muted-color">{{ u.ufSolicitante }}</span>
                        </td>
                        <td><p-button label="Selecionar" size="small" (onClick)="selecionarUsuario(u)"></p-button></td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center text-muted-color py-6">Nenhum usuário encontrado.</td>
                    </tr>
                </ng-template>
            </p-table>
        } @else {
            @if (usuariosFiltrados().length === 0) {
                <div class="flex flex-col items-center gap-3 text-muted-color py-10">
                    <i class="pi pi-users text-4xl opacity-20"></i>
                    <span class="text-sm">Nenhum usuário encontrado.</span>
                </div>
            }
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                @for (u of usuariosPaginados(); track u.id) {
                    <app-card-container>
                        <div class="flex flex-col gap-3 p-1">
                            <div class="flex items-center gap-3">
                                <app-pessoa-avatar [foto]="u.avatar" [iniciais]="iniciais(u.nmSolicitante || u.userId)" [nome]="u.nmSolicitante || ''" tamanho="xl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, u.nmSolicitante || '')" />
                                <div class="flex flex-col gap-0.5 min-w-0">
                                    <span class="font-semibold text-sm leading-tight truncate">{{ u.nmSolicitante || '—' }}</span>
                                    @if (u.cpf) {
                                        <span class="text-xs text-muted-color">{{ u.cpf }}</span>
                                    }
                                </div>
                            </div>
                            <div class="grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
                                <div class="text-muted-color">UF</div>
                                <div class="font-semibold">{{ u.ufSolicitante }}</div>
                                <div class="text-muted-color col-span-2 font-mono opacity-60 truncate" [title]="u.userId">{{ u.userId }}</div>
                            </div>
                            <div class="flex justify-end pt-1 border-t border-surface-200 dark:border-surface-700">
                                <p-button label="Selecionar" size="small" (onClick)="selecionarUsuario(u)"></p-button>
                            </div>
                        </div>
                    </app-card-container>
                }
            </div>
            @if (usuariosFiltrados().length > 0) {
                <p-paginator
                    [first]="cardPage() * cardPageSize()"
                    [rows]="cardPageSize()"
                    [totalRecords]="usuariosFiltrados().length"
                    [rowsPerPageOptions]="[15, 30, 50]"
                    (onPageChange)="onCardPageChange($event)"
                    class="mt-4 border-t border-surface-200 dark:border-surface-700 pt-3"
                />
            }
        }
    } @else if (carregando()) {
        <div class="p-4 text-center"><i class="pi pi-spin pi-spinner"></i></div>
    } @else if (erroCarregar()) {
        <div class="p-4 text-center texto-aviso">
            <i class="pi pi-exclamation-triangle mr-2"></i>
            Não foi possível carregar as roles deste usuário. Verifique se o User ID no Keycloak é válido.
        </div>
    } @else {
        <div class="flex items-center justify-between gap-2 mb-3 flex-wrap">
            <div class="flex flex-wrap gap-3 text-sm items-center">
                <span class="text-muted-color">Legenda:</span>
                <span class="flex items-center gap-1.5"><span class="acao-dot tipo-C"></span>Criar</span>
                <span class="flex items-center gap-1.5"><span class="acao-dot tipo-R"></span>Visualizar</span>
                <span class="flex items-center gap-1.5"><span class="acao-dot tipo-U"></span>Editar</span>
                <span class="flex items-center gap-1.5"><span class="acao-dot tipo-D"></span>Excluir</span>
                <span class="flex items-center gap-1.5"><span class="acao-dot tipo-E"></span>Específica</span>
            </div>
            <div class="flex items-center gap-2">
                <p-button
                    label="Remover todas roles"
                    icon="pi pi-eraser"
                    severity="danger"
                    [text]="true"
                    styleClass="btn-remover-todas"
                    [disabled]="!podeRemoverTudo()"
                    [loading]="removendoTodas()"
                    [pTooltip]="ehProprioUsuario() ? 'Não é possível remover as próprias roles.' : ''"
                    tooltipPosition="top"
                    (onClick)="confirmarRemoverTodas()"
                    [appCan]="rolePermissaoAdministrar"
                ></p-button>
                <p-button label="Aplicar perfil" icon="pi pi-id-card" severity="secondary" [disabled]="!userIdAtivo()" (onClick)="abrirDialogPerfil()" [appCan]="rolePermissaoAdministrar"></p-button>
                <p-button label="Salvar" icon="pi pi-check" [disabled]="!temAlteracoes() || salvando()" [loading]="salvando()" (onClick)="salvar()" [appCan]="rolePermissaoAdministrar"></p-button>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-folder" [title]="'Módulos'">
                <div class="flex flex-col gap-1">
                    @for (mod of grupos(); track mod.modulo) {
                        <div class="kanban-item flex justify-between items-center" [class.is-sel]="mod.modulo === moduloSel()" (click)="selecionarModulo(mod)">
                            <span>{{ mod.moduloLabel }}</span>
                            <span class="text-xs text-muted-color">{{ mod.total }}</span>
                        </div>
                    }
                </div>
            </app-card-content>

            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-list" [title]="'Funcionalidades'">
                @if (moduloAtual(); as mod) {
                    <div class="flex flex-col gap-1">
                        @for (f of mod.funcionalidades; track f.funcionalidade) {
                            <div class="kanban-item" [class.is-sel]="f.funcionalidade === funcSel()" (click)="selecionarFunc(f)">{{ f.funcionalidadeLabel }}</div>
                        }
                    </div>
                } @else {
                    <div class="text-muted-color text-sm p-2">Selecione um módulo.</div>
                }
            </app-card-content>

            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-bolt" [title]="'Ações'">
                @if (funcAtual(); as f) {
                    <p class="text-xs text-muted-color mb-3 flex items-center gap-1">
                        <i class="pi pi-info-circle"></i>
                        Ative para conceder. As mudanças valem ao clicar em Salvar.
                    </p>

                    @if (f.crud.length) {
                        <div class="flex items-center justify-between gap-2 px-2 py-2 rounded-lg bg-surface-100 dark:bg-surface-800 mb-2">
                            <span class="text-sm font-medium">Conceder tudo (CRUD)</span>
                            <p-toggleswitch [ngModel]="crudTodas(f)" (ngModelChange)="toggleCrud(f)" />
                        </div>
                        <div class="flex flex-col">
                            @for (a of f.crud; track a.role) {
                                <div class="flex items-center justify-between gap-2 py-2 border-b border-surface-200 dark:border-surface-700 last:border-b-0">
                                    <div class="flex items-center gap-2 min-w-0">
                                        <span class="acao-dot tipo-{{ a.crud }}"></span>
                                        <span class="text-sm truncate">{{ a.acaoLabel }}</span>
                                    </div>
                                    <div class="flex items-center gap-2 shrink-0">
                                        <span class="text-xs" [class.text-green-600]="marcada(a.role)" [class.text-muted-color]="!marcada(a.role)">{{ marcada(a.role) ? 'Concedida' : 'Não concedida' }}</span>
                                        <p-toggleswitch [ngModel]="marcada(a.role)" (ngModelChange)="toggle(a.role)" />
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    @if (f.especificas.length) {
                        <div class="text-xs font-semibold uppercase tracking-wide text-muted-color mt-4 mb-1">Específicas</div>
                        <div class="flex flex-col">
                            @for (a of f.especificas; track a.role) {
                                <div class="flex items-center justify-between gap-2 py-2 border-b border-surface-200 dark:border-surface-700 last:border-b-0">
                                    <div class="flex items-center gap-2 min-w-0">
                                        <span class="acao-dot tipo-E"></span>
                                        <span class="text-sm truncate">{{ a.acaoLabel }}</span>
                                    </div>
                                    <div class="flex items-center gap-2 shrink-0">
                                        <span class="text-xs" [class.text-green-600]="marcada(a.role)" [class.text-muted-color]="!marcada(a.role)">{{ marcada(a.role) ? 'Concedida' : 'Não concedida' }}</span>
                                        <p-toggleswitch [ngModel]="marcada(a.role)" (ngModelChange)="toggle(a.role)" />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                } @else {
                    <div class="text-muted-color text-sm p-2">Selecione uma funcionalidade.</div>
                }
            </app-card-content>
        </div>
    }
</app-card-content>

<p-dialog appDialogoPadrao="pi pi-shield" descricao="As permissões do perfil serão atribuídas ao usuário." header="Aplicar perfil" [visible]="dialogPerfilAberto()" [style]="{ width: '56rem', maxWidth: '95vw' }" (onHide)="fecharDialogPerfil()">
    <p class="text-base text-muted-color mb-3">
        Escolha um perfil para <strong>adicionar</strong> as roles dele a <strong>{{ nomeAtivo() || userIdAtivo() }}</strong
        >. As roles são somadas — nada é removido.
    </p>

    @if (carregandoPerfis()) {
        <div class="p-4 text-center"><i class="pi pi-spin pi-spinner"></i></div>
    } @else if (!perfilSel()) {
        <div class="flex flex-col gap-1 max-h-[70vh] overflow-y-auto pr-1">
            @for (grupo of perfisPorUf(); track grupo.uf) {
                <div class="flex items-center gap-2 px-2 pt-3 pb-1">
                    <app-estado-rotulo [uf]="grupo.uf" class="font-semibold" />
                    <span class="text-sm text-muted-color">{{ grupo.perfis.length }} perfil(is)</span>
                </div>
                @for (p of grupo.perfis; track p.id) {
                    <div class="rounded hover:bg-surface-100 dark:hover:bg-surface-800">
                        <div class="flex items-center justify-between gap-2 px-2 py-2">
                            <div class="flex flex-col">
                                <span class="text-base font-medium">{{ p.nmPerfil }}</span>
                                <span class="text-sm text-muted-color">{{ p.qtdRoles }} role(s)</span>
                            </div>
                            <div class="flex items-center gap-1 shrink-0">
                                <p-button
                                    [label]="perfilExpandidoId() === p.id ? 'Ocultar roles' : 'Exibir roles'"
                                    [icon]="perfilExpandidoId() === p.id ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                                    iconPos="right"
                                    size="small"
                                    [text]="true"
                                    severity="secondary"
                                    (onClick)="toggleExibirRoles(p)"
                                ></p-button>
                                <p-button label="Selecionar" size="small" [text]="true" (onClick)="selecionarPerfil(p)"></p-button>
                            </div>
                        </div>
    
                        @if (perfilExpandidoId() === p.id) {
                            <div class="px-2 pb-3">
                                @if (carregandoExpansao()) {
                                    <div class="p-3 text-center text-muted-color"><i class="pi pi-spin pi-spinner"></i></div>
                                } @else if (erroExpansao()) {
                                    <div class="text-sm text-red-600 dark:text-red-400 flex items-center gap-1.5 p-2">
                                        <i class="pi pi-exclamation-triangle"></i>
                                        Não foi possível carregar as roles deste perfil.
                                    </div>
                                } @else if (gruposExpandidos().length) {
                                    <div class="flex flex-col gap-3 bg-surface-50 dark:bg-surface-900 rounded-lg p-3">
                                        @for (mod of gruposExpandidos(); track mod.modulo) {
                                            <div>
                                                <div class="flex items-center justify-between gap-2 text-sm font-semibold uppercase tracking-wide text-muted-color">
                                                    <span>{{ mod.moduloLabel }}</span>
                                                    <span>{{ mod.total }}</span>
                                                </div>
                                                <div class="flex flex-col gap-1 mt-1.5">
                                                    @for (f of mod.funcionalidades; track f.funcionalidade) {
                                                        @for (a of f.todas; track a.role) {
                                                            <span class="text-sm font-mono text-surface-700 dark:text-surface-200 break-all whitespace-normal">{{ a.role }}</span>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div class="text-sm text-muted-color p-2">Este perfil não possui roles.</div>
                                }
                            </div>
                        }
                    </div>
                }
            } @empty {
                <div class="text-base text-muted-color px-2 py-2">Nenhum perfil ativo encontrado.</div>
            }
        </div>
    } @else if (carregandoPerfilSel()) {
        <div class="p-4 text-center"><i class="pi pi-spin pi-spinner"></i></div>
    } @else {
        <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between gap-2">
                <span class="font-semibold text-base">{{ perfilSel()!.nmPerfil }}</span>
                <p-button label="Trocar perfil" icon="pi pi-arrow-left" size="small" [text]="true" severity="secondary" (onClick)="perfilSel.set(null)"></p-button>
            </div>
            <div class="text-sm text-muted-color flex items-center gap-1.5 bg-surface-100 dark:bg-surface-800 rounded-lg px-3 py-2">
                <i class="pi pi-info-circle"></i>
                Nenhuma role atual do usuário será removida por esta ação.
            </div>
            @if (rolesPerfilAdicionadas().length) {
                <div>
                    <div class="text-sm font-semibold uppercase tracking-wide text-muted-color mb-1">Serão adicionadas ({{ rolesPerfilAdicionadas().length }})</div>
                    <div class="flex flex-col gap-1 max-h-48 overflow-auto">
                        @for (r of rolesPerfilAdicionadas(); track r) {
                            <span class="text-sm font-mono">{{ r }}</span>
                        }
                    </div>
                </div>
            } @else {
                <div class="text-base text-muted-color">O usuário já possui todas as roles deste perfil. Nada será alterado.</div>
            }
        </div>
    }

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" (onClick)="fecharDialogPerfil()"></p-button>
        <p-button label="Aplicar" icon="pi pi-check" [disabled]="!perfilSel() || aplicandoPerfil()" [loading]="aplicandoPerfil()" [appCan]="rolePermissaoAdministrar" (onClick)="confirmarAplicarPerfil()"></p-button>
    </ng-template>
</p-dialog>

<p-confirmdialog></p-confirmdialog>

<app-pessoa-foto-dialog [(foto)]="fotoAmpliada" [nome]="nomeFotoAmpliada()" />
